import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Container,
  Court,
  AnimatorBar,
  Navbar,
  DurationForm,
  RedDot,
  BallDot,
  BlueDot,
  WidgetContainer,
  AnimatorBarContainer,
} from "./styled";
import { Loader } from "../../../components";

export default function VideoPlayer(jugadaData) {
  const { name, animations } = jugadaData.jugada;
  const [animationRunning, setAnimationRunning] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [firstClickPlay, setFirstClickPlay] = useState(true);
  const [animatiomultipliedspeed, setAnimatiomultipliedspeed] = useState(false);
  const [animationLoopState, setAnimationLoopState] = useState(false);
  const [loopIterations, setLoopIterations] = useState(1);
  const [animationSpeed, setAnimationSpeed] = useState(1);
  const [windowDimensions, setWindowDimensions] = useState(0);
  const location = useLocation();
  const animationContainerRef = useRef(null);
  let slug =
    location.pathname.indexOf("playVideos") > -1
      ? location.pathname.replace("/playVideos/", "")
      : location.pathname.replace("/recordVideos/", "");
  slug.replace("/record", "");

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }
  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("load", handleResize);
    setWindowDimensions(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    if (jugadaData.isRecord && windowDimensions.width !== undefined) {
      let AnimationLength;
      if (animations.desktop.own?.length) {
        AnimationLength = animationSpeed * animations.desktop.own[0].length;
      } else if (animations.desktop.rivals?.length) {
        AnimationLength = animationSpeed * animations.desktop.rivals[0].length;
      } else if (animations.desktop.ball?.length) {
        AnimationLength = animationSpeed * animations.desktop.ball[0].length;
      }
      setAnimationSpeed(AnimationLength);
    }
    if (
      jugadaData.isRecord &&
      windowDimensions.width !== undefined &&
      animationSpeed > 1
    ) {
      play();
    }
  }, [jugadaData.isRecord, windowDimensions.width, animationSpeed]);

  const onFinishAnimation = () => {
    setAnimationRunning(false);
    setFirstClickPlay(true);
    var player0 = document.getElementById("0");
    var player1 = document.getElementById("1");
    var player2 = document.getElementById("2");
    var player3 = document.getElementById("3");
    var player4 = document.getElementById("4");
    var rival0 = document.getElementById("b-0");
    var rival1 = document.getElementById("b-1");
    var rival2 = document.getElementById("b-2");
    var rival3 = document.getElementById("b-3");
    var rival4 = document.getElementById("b-4");
    var ball = document.getElementById("ball");
    if (animations?.hasOwnProperty("own")) {
      animations.own.forEach((player, i) => {
        switch (i) {
          case 0:
            player0.style.left = `${animations.own[0].left}`;
            player0.style.top = `${animations.own[0].top}`;
            break;
          case 1:
            player1.style.left = `${animations.own[0].left}`;
            player1.style.top = `${animations.own[0].top}`;
            break;
          case 2:
            player2.style.left = `${animations.own[0].left}`;
            player2.style.top = `${animations.own[0].top}`;
            break;
          case 3:
            player3.style.left = `${animations.own[0].left}`;
            player3.style.top = `${animations.own[0].top}`;
            break;
          case 4:
            player4.style.left = `${animations.own[0].left}`;
            player4.style.top = `${animations.own[0].top}`;
            break;
          default:
            break;
        }
      });
    }
    if (animations?.hasOwnProperty("rivals")) {
      animations?.rivals.forEach((player, i) => {
        switch (i) {
          case 0:
            rival0.style.left = `${animations.rivals[0].left}`;
            rival0.style.top = `${animations.rivals[0].top}`;
            break;
          case 1:
            rival1.style.left = `${animations.rivals[0].left}`;
            rival1.style.top = `${animations.rivals[0].top}`;
            break;
          case 2:
            rival2.style.left = `${animations.rivals[0].left}`;
            rival2.style.top = `${animations.rivals[0].top}`;
            break;
          case 3:
            rival3.style.left = `${animations.rivals[0].left}`;
            rival3.style.top = `${animations.rivals[0].top}`;
            break;
          case 4:
            rival4.style.left = `${animations.rivals[0].left}`;
            rival4.style.top = `${animations.rivals[0].top}`;
            break;
          default:
            break;
        }
      });
    }
    if (animations?.hasOwnProperty("ball")) {
      animations?.ball.forEach((movimiento, index) => {
        ball.style.left = `${movimiento[0].left}`;
        ball.style.top = `${movimiento[0].top}`;
      });
    }
  };

  //animacion de los jugadores
  const play = () => {
    setAnimationRunning(true);
    if (firstClickPlay) {
      var player0 = document.getElementById("0");
      var player1 = document.getElementById("1");
      var player2 = document.getElementById("2");
      var player3 = document.getElementById("3");
      var player4 = document.getElementById("4");
      var rival0 = document.getElementById("b-0");
      var rival1 = document.getElementById("b-1");
      var rival2 = document.getElementById("b-2");
      var rival3 = document.getElementById("b-3");
      var rival4 = document.getElementById("b-4");
      var ball = document.getElementById("ball");

      const animationInfo = {
        duration: !animatiomultipliedspeed
          ? animationSpeed * 1000
          : (animationSpeed * 1000) / 2,
        iterations: loopIterations,
      };
      if (windowDimensions && windowDimensions.width <= 867) {
        if (animations?.mobile.hasOwnProperty("own")) {
          animations?.mobile.own.forEach((movimiento, i) => {
            switch (i) {
              case 0:
                player0?.animate(movimiento, animationInfo);
                break;
              case 1:
                player1?.animate(movimiento, animationInfo);
                break;
              case 2:
                player2?.animate(movimiento, animationInfo);
                break;
              case 3:
                player3?.animate(movimiento, animationInfo);
                break;
              case 4:
                player4?.animate(movimiento, animationInfo);
                break;
              default:
                break;
            }
          });
        }
        if (animations?.mobile.hasOwnProperty("rivals")) {
          animations?.mobile.rivals.forEach((movimiento, i) => {
            switch (i) {
              case 0:
                rival0?.animate(movimiento, animationInfo);
                break;
              case 1:
                rival1?.animate(movimiento, animationInfo);
                break;
              case 2:
                rival2?.animate(movimiento, animationInfo);
                break;
              case 3:
                rival3?.animate(movimiento, animationInfo);
                break;
              case 4:
                rival4?.animate(movimiento, animationInfo);
                break;
              default:
                break;
            }
          });
        }
        if (animations?.mobile.hasOwnProperty("ball")) {
          animations?.mobile.ball.forEach((movimiento, index) => {
            ball?.animate(movimiento, animationInfo);
          });
        }
      } else if (windowDimensions && windowDimensions.width >= 867) {
        if (animations?.desktop.hasOwnProperty("own")) {
          animations?.desktop.own.forEach((movimiento, i) => {
            switch (i) {
              case 0:
                player0?.animate(movimiento, animationInfo);
                break;
              case 1:
                player1?.animate(movimiento, animationInfo);
                break;
              case 2:
                player2?.animate(movimiento, animationInfo);
                break;
              case 3:
                player3?.animate(movimiento, animationInfo);
                break;
              case 4:
                player4?.animate(movimiento, animationInfo);
                break;
              default:
                break;
            }
          });
        }
        if (animations?.desktop.hasOwnProperty("rivals")) {
          animations?.desktop.rivals.forEach((movimiento, i) => {
            switch (i) {
              case 0:
                rival0?.animate(movimiento, animationInfo);
                break;
              case 1:
                rival1?.animate(movimiento, animationInfo);
                break;
              case 2:
                rival2?.animate(movimiento, animationInfo);
                break;
              case 3:
                rival3?.animate(movimiento, animationInfo);
                break;
              case 4:
                rival4?.animate(movimiento, animationInfo);
                break;
              default:
                break;
            }
          });
        }
        if (animations?.desktop.hasOwnProperty("ball")) {
          animations?.desktop.ball.forEach((movimiento, index) => {
            ball?.animate(movimiento, animationInfo);
          });
        }
      }
      //END ANIMATION
      var players = document.getAnimations();
      if (players.length > 0) {
        players[0].onfinish = (event) => {
          onFinishAnimation();
        };
      } else alert("No hay animaciones realizadas");
      setFirstClickPlay(false);
    } else {
      setAnimationRunning(true);
      let playersAnimation = document.getAnimations();
      playersAnimation.forEach((player, i) => {
        player.play();
      });
    }
  };
  //fin de la animacion de los jugadores

  const handleLoop = () => {
    var loopstate = !animationLoopState;
    setAnimationLoopState(!animationLoopState);
    if (loopstate) {
      setLoopIterations("Infinity");
    } else {
      setLoopIterations(1);
      document.getAnimations().forEach(function (animation) {
        animation.cancel();
      });
      setAnimationRunning(false);
      setFirstClickPlay(true);
    }
  };

  //RELOAD POSITIONS
  const reloadPostions = () => {
    setAnimationLoopState(false);
    setLoopIterations(1);
    setAnimationRunning(false);
    setFirstClickPlay(true);
    var players = document.getAnimations();
    players.forEach(function (animation) {
      animation.cancel();
    });
  };
  // END OF RELOAD POSITIONS

  //MULTIPLIE SPEED FUNCTION
  const multiplySpeed = () => {
    var speedState = !animatiomultipliedspeed;
    setAnimatiomultipliedspeed(speedState);
  };
  //END OF MULTIPLIE SPEED

  //PAUSE ANIMATION
  const pause = () => {
    setAnimationRunning(false);
    //Get all the AnimationPlayers
    var players;
    if (typeof document.getAnimations === "function") {
      players = document.getAnimations();
    } else {
      players = document.timeline.getAnimations();
    }
    if (players && players.length) {
      var action;
      if (players[0].playState === "running") {
        action = "pause";
      } else if (players[0].playState === "paused") {
        action = "play";
      } else {
        return;
      }
      players.forEach(function (player, i, ra) {
        player[action](); //player.pause() or player.play()
      });

      //button.value = action === "play" ? "Pause All" : "Play All";
    } else {
      console.log("no more actions");
    }
  };
  //END OF PAUSE ANIMATION

  const renderRivals = () => {
    if (animations) {
      let exists_desktop = animations.desktop.hasOwnProperty("rivals");
      let exists_mobile = animations.desktop.hasOwnProperty("rivals");
      if (exists_desktop && windowDimensions && windowDimensions.width >= 867) {
        return animations.desktop.rivals.map((Widget, i) => (
          <>
            {animations.desktop.rivals[i].length > 0 ? (
              <WidgetContainer
                id={`b-${i}`}
                key={`b-${i}`}
                grid={[1, 1]}
                scale={1}
                style={{
                  top: `${animations.desktop.rivals[i][0].top}`,
                  left: `${animations.desktop.rivals[i][0].left}`,
                }}
              >
                <BlueDot className="handle" id={`b-${i}`}>
                  <p>{i + 1}</p>
                </BlueDot>
              </WidgetContainer>
            ) : null}
          </>
        ));
      } else if (
        exists_mobile &&
        windowDimensions &&
        windowDimensions.width <= 867
      ) {
        return animations.mobile.rivals.map((Widget, i) => (
          <>
            {animations.mobile.rivals[i].length > 0 ? (
              <WidgetContainer
                id={`b-${i}`}
                key={`b-${i}`}
                grid={[1, 1]}
                scale={1}
                style={{
                  top: `${animations.mobile.rivals[i][0].top}`,
                  left: `${animations.mobile.rivals[i][0].left}`,
                }}
              >
                <BlueDot className="handle" id={`b-${i}`}>
                  <p>{i + 1}</p>
                </BlueDot>
              </WidgetContainer>
            ) : null}
          </>
        ));
      }
    }
  };
  const renderOwn = () => {
    if (animations) {
      let exists_desktop = animations.desktop.hasOwnProperty("own");
      let exists_mobile = animations.desktop.hasOwnProperty("own");
      if (exists_desktop && windowDimensions && windowDimensions.width >= 867) {
        return animations.desktop.own.map((Widget, i) => (
          <>
            {animations.desktop.own[i].length > 0 ? (
              <WidgetContainer
                id={i}
                key={i}
                grid={[1, 1]}
                scale={1}
                style={{
                  top: `${animations.desktop.own[i][0].top}`,
                  left: `${animations.desktop.own[i][0].left}`,
                }}
              >
                <RedDot className="handle" id={i}>
                  <p>{i + 1}</p>
                </RedDot>
              </WidgetContainer>
            ) : null}
          </>
        ));
      } else if (
        exists_mobile &&
        windowDimensions &&
        windowDimensions.width <= 867
      ) {
        return animations.mobile.own.map((Widget, i) => (
          <>
            {animations.mobile.own[i].length > 0 ? (
              <WidgetContainer
                id={i}
                key={i}
                grid={[1, 1]}
                scale={1}
                style={{
                  top: `${animations.mobile.own[i][0].top}`,
                  left: `${animations.mobile.own[i][0].left}`,
                }}
              >
                <RedDot className="handle" id={i}>
                  <p>{i + 1}</p>
                </RedDot>
              </WidgetContainer>
            ) : null}
          </>
        ));
      }
    }
  };

  const renderBall = () => {
    if (animations) {
      let exists_desktop = animations.desktop.hasOwnProperty("ball");
      let exists_mobile = animations.desktop.hasOwnProperty("ball");
      if (exists_desktop && windowDimensions && windowDimensions.width >= 867) {
        return animations.desktop.ball.map((Widget, i) => (
          <>
            {animations.desktop.ball[i].length > 0 ? (
              <WidgetContainer
                id="ball"
                key={`ball-${i}`}
                grid={[1, 1]}
                scale={1}
                style={{
                  top: `${animations.desktop.ball[i][0].top}`,
                  left: `${animations.desktop.ball[i][0].left}`,
                }}
              >
                <BallDot className="handle" id="ball"></BallDot>
              </WidgetContainer>
            ) : null}
          </>
        ));
      } else if (
        exists_mobile &&
        windowDimensions &&
        windowDimensions.width <= 867
      ) {
        return animations.mobile.ball.map((Widget, i) => (
          <>
            {animations.mobile.ball[0].length > 0 ? (
              <WidgetContainer
                id="ball"
                key={`ball-${i}`}
                grid={[1, 1]}
                scale={1}
                style={{
                  top: `${animations.mobile.ball[0][0].top}`,
                  left: `${animations.mobile.ball[0][0].left}`,
                }}
              >
                <BallDot className="handle" id="ball"></BallDot>
              </WidgetContainer>
            ) : null}
          </>
        ));
      }
    }
  };
  const handleDurationSum = () => {
    setAnimationSpeed(animationSpeed + 1);
  };
  const handleDurationRes = () => {
    setAnimationSpeed(animationSpeed - 1);
  };

  if (isLoading) {
    return <Loader />;
  }
  const recordVideoCanvas = async () => {
    var sBrowser,
      sUsrAg = navigator.userAgent;

    // The order matters here, and this may report false positives for unlisted browsers.

    if (sUsrAg.indexOf("Firefox") > -1) {
      sBrowser = "Mozilla Firefox";
      // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
    } else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
      sBrowser = "Samsung Internet";
      // "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
    } else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
      sBrowser = "Opera";
      // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
    } else if (sUsrAg.indexOf("Trident") > -1) {
      sBrowser = "Microsoft Internet Explorer";
      // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
    } else if (sUsrAg.indexOf("Edge") > -1) {
      sBrowser = "Microsoft Edge";
      // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
    } else if (sUsrAg.indexOf("Chrome") > -1) {
      sBrowser = "Google Chrome or Chromium";
      // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
    } else if (sUsrAg.indexOf("Safari") > -1) {
      sBrowser = "Apple Safari";
      // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
    } else {
      sBrowser = "unknown";
    }
    var container = document.getElementById("layout");
    var canvas = document.createElement("canvas");
    canvas.width = windowDimensions.width;
    canvas.height = windowDimensions.height;
    container.appendChild(canvas);
    const ctx = canvas?.getContext("2d");
    const courtLines = new Image();
    const woodBackground = new Image();
    courtLines.onload = function () {
      ctx?.drawImage(courtLines, 0, 0, canvas.width, canvas.height);
      ctx?.drawImage(woodBackground, 0, 0, canvas.width, canvas.height);
    };
    if (windowDimensions.width >= 867)
      courtLines.src = "/assets/court-lines.png";
    else if (windowDimensions.width < 867)
      courtLines.src = "/assets/court-vertical.png";
    woodBackground.src = "/assets/court-backgorund.jpg";
    const img = new Image();
    let pattern;
    let startTime = null;
    let animation = null;
    const duration = 1000; // Duration of the animation in milliseconds
    const startRecording = () => {
      setIsLoading(true);
      animate(performance.now());
      const chunks = []; // here we will store our recorded media chunks (Blobs)
      const stream = canvas.captureStream(30); // grab our canvas MediaStream
      const options = {
        videoBitsPerSecond: 2500000,
        mimeType: sBrowser === "Apple Safari" ? "video/mp4" : "video/webm",
      };
      const rec = new MediaRecorder(stream, options); // init the recorder
      // every time the recorder has new data, we will store it in our array
      rec.ondataavailable = (e) => chunks.push(e.data);
      // only when the recorder stops, we construct a complete Blob from all the chunks
      if (animation === null) rec.stop();
      rec.onstop = (e) => {
        // downloadVideo(new Blob(chunks, { type: "video/mp4;codecs=h264" }));
        const blob = new Blob(chunks, {
          type:
            sUsrAg.indexOf("Safari") > -1
              ? "video/mp4"
              : "video/webm;codecs=h264",
        });
        downloadVideo(blob);
      };
      rec.start();
      setTimeout(() => {
        rec.stop();
      }, animations.desktop.own[0].length * 1000); // stop recording in Xs
    };
    startRecording();
    img.onload = function () {
      pattern = ctx?.createPattern(img, "no-repeat");
      ctx.fillStyle = pattern;
    };
    img.onerror = function () {
      console.error("Failed to load the image");
    };
    img.src = "/assets/Ball.png";
    async function drawBall(x, y, type, text) {
      if (type === "ball") {
        ctx.fillStyle = pattern;
      } else if (type === "own") {
        ctx.fillStyle = "#c4342c";
      } else if (type === "rivals") {
        ctx.fillStyle = "blue";
      } else {
        ctx.fillStyle = null;
      }
      if (type === "ball") {
        if (windowDimensions.width >= 867) ctx.drawImage(img, x, y);
        else if (windowDimensions.width < 867) ctx.drawImage(img, x, y, 30, 30);
      } else {
        ctx.beginPath();
        if (windowDimensions.width >= 867) ctx.arc(x, y, 25, 0, 2 * Math.PI);
        else if (windowDimensions.width < 867)
          ctx.arc(x, y, 15, 0, 2 * Math.PI);
        ctx.fill();
        ctx.closePath();
        ctx.fillStyle = "white"; // Set the color of the text
        ctx.font = "normal 20px system-ui"; // Set the font style, size, and font family
        ctx.textAlign = "center"; // Set the alignment of the text

        // Specify the position of the text based on the object's coordinates
        ctx.fillText(text, x, y + 9);
      }
    }

    function clearCanvas() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(woodBackground, 0, 0, canvas.width, canvas.height);
      ctx.drawImage(courtLines, 0, 0, canvas.width, canvas.height);
    }

    function lerp(start, end, progress) {
      return start + (end - start) * progress;
    }

    function animate(timestamp) {
      if (!startTime) {
        startTime = timestamp;
      }

      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1); // Animation progress between 0 and 1

      clearCanvas();

      // Loop through all the objects in the animations object
      let responsiveAnimation;
      if (windowDimensions.width >= 867)
        responsiveAnimation = animations.desktop;
      else if (windowDimensions.width < 867)
        responsiveAnimation = animations.mobile;
      for (const objectKey in responsiveAnimation) {
        if (responsiveAnimation.hasOwnProperty(objectKey)) {
          for (var i = 0; i < responsiveAnimation[objectKey].length; i++) {
            const positions = responsiveAnimation[objectKey][i];

            const start = positions[0];
            const end = positions[1];

            const startX = (parseFloat(start.left) / 100) * canvas.width;
            const startY = (parseFloat(start.top) / 100) * canvas.height;
            let endX;
            let endY;
            if (end !== undefined) {
              endX = (parseFloat(end.left) / 100) * canvas.width;
              endY = (parseFloat(end.top) / 100) * canvas.height;
            } else {
              endX = (parseFloat(start.left) / 100) * canvas.width;
              endY = (parseFloat(start.top) / 100) * canvas.height;
            }

            const x = lerp(startX, endX, progress);
            const y = lerp(startY, endY, progress);

            drawBall(x, y, objectKey, i + 1);
          }
        }
      }

      if (progress >= 1) {
        // Shift the first position from each object's positions array
        for (const objectKey in responsiveAnimation) {
          for (var i = 0; i < responsiveAnimation[objectKey].length; i++) {
            if (responsiveAnimation.hasOwnProperty(objectKey)) {
              responsiveAnimation[objectKey][i].shift();
            }
          }
        }
        startTime = null;
      }

      // Check if there are any positions left in any of the objects
      let hasPositionsLeft = false;
      for (const objectKey in responsiveAnimation) {
        if (responsiveAnimation.hasOwnProperty(objectKey)) {
          if (responsiveAnimation[objectKey][0].length > 0) {
            hasPositionsLeft = true;
            break;
          }
        }
      }

      if (hasPositionsLeft) {
        animation = requestAnimationFrame(animate);
      } else {
        cancelAnimationFrame(animation);
        animation = null;
      }
    }

    const downloadVideo = async (blob) => {
      const div = document.querySelector("div");
      var url = URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;
      a.download = `${name}.webm`;
      a.className = "button";
      a.innerText = "click here to download";
      div.appendChild(a);
      a.click();
      container.removeChild(canvas);
      setIsLoading(false);
    };
  };

  return (
    <>
      <Navbar className={`${jugadaData.isRecord ? "hide" : null}`}>
        <div
          onClick={(e) => recordVideoCanvas(e)}
          className="download_button-container"
        >
          <div className="download_button">
            <img
              src="/assets/download-icon.png"
              alt="download button to record video and download it"
            ></img>
            <p>Descargar</p>
          </div>
        </div>
        <div className="back-arrow-container">
          <Link to="/app/main">
            <img src="/assets/BackArrow.png" href="../index" alt="back arrow" />
          </Link>
          <h1>Tacticas</h1>
        </div>
      </Navbar>
      <Container isExport={jugadaData.isRecord}>
        <Court
          id="Court"
          isExport={jugadaData.isRecord}
          ref={animationContainerRef}
        >
          <img
            src="/assets/court-vertical.png"
            alt="square-icon"
            className="court-img-m"
          />
          <img
            src="/assets/court-lines.png"
            alt="square-icon"
            className="court-img"
          />
          {animations !== undefined ? renderOwn() : null}
          {animations !== undefined ? renderRivals() : null}
          {animations !== undefined ? renderBall() : null}
        </Court>
        <div></div>
        <AnimatorBar id="elemnt-to-remove" isExport={jugadaData.isRecord}>
          <p
            className="controls"
            style={windowDimensions.width <= 867 ? { display: "none" } : null}
          >
            Controles
          </p>
          {!animationRunning ? (
            <AnimatorBarContainer id="playBtn" onClick={play}>
              <img src="/assets/Play-icon.svg" alt="Play animation icon" />
            </AnimatorBarContainer>
          ) : (
            <AnimatorBarContainer onClick={pause}>
              <img src="/assets/pause-icon.png" alt="nada" />
            </AnimatorBarContainer>
          )}
          <AnimatorBarContainer onClick={reloadPostions}>
            <img src="/assets/square-icon.png" alt="nada" />
          </AnimatorBarContainer>
          <AnimatorBarContainer
            onClick={multiplySpeed}
            className={`lastContainers ${
              animatiomultipliedspeed ? "loop-active" : "loop-unactive"
            }`}
          >
            <p>2X</p>
          </AnimatorBarContainer>
          <AnimatorBarContainer
            onClick={handleLoop}
            className={`${
              animationLoopState ? "loop-active" : "loop-unactive"
            }`}
          >
            <img src="/assets/loop-icon.png" alt="nada" />
          </AnimatorBarContainer>
          <AnimatorBarContainer id="speedContainer">
            <DurationForm>
              <p>Duración</p>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  setAnimationSpeed(e.target[0].value);
                }}
              >
                <button name="minus" type="button" onClick={handleDurationRes}>
                  -
                </button>
                <input
                  id="duration-input"
                  value={animationSpeed}
                  onChange={(e) => setAnimationSpeed(e.target.value)}
                />
                <button name="plus" type="button" onClick={handleDurationSum}>
                  +
                </button>
              </form>
            </DurationForm>
          </AnimatorBarContainer>
          <p className="nameText">{name}</p>
        </AnimatorBar>
      </Container>
      <canvas id="canvas" width="640" height="360"></canvas>
    </>
  );
}
